import { FaWhatsapp } from "react-icons/fa";
import { CONTACT } from "@/data/site";
import { useBooking } from "@/components/site/BookingContext";

export const MobileCTABar = () => {
  const { openBooking } = useBooking();

  return (
    <div
      data-testid="mobile-cta-bar"
      className="md:hidden fixed bottom-0 left-0 right-0 z-[66] grid grid-cols-2 border-t border-brand-black/10 bg-white shadow-[0_-6px_20px_-8px_rgba(0,0,0,0.2)]"
    >
      <a
        href={`https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent("Ciao! Vorrei informazioni sui vostri corsi.")}`}
        target="_blank"
        rel="noreferrer"
        data-testid="mcta-whatsapp"
        className="flex items-center justify-center gap-2 py-4 text-[#25D366] font-bold uppercase tracking-widest text-sm border-r border-brand-black/10"
      >
        <FaWhatsapp size={20} /> WhatsApp
      </a>
      <button
        onClick={() => openBooking()}
        data-testid="mcta-iscriviti"
        className="flex items-center justify-center py-4 bg-brand-red text-white font-bold uppercase tracking-widest text-sm"
      >
        Iscriviti
      </button>
    </div>
  );
};
